var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShoppingBagIcon = function SvgShoppingBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7V2.846C5 2.231 5.4 1 7 1M9 7V2.846C9 2.231 8.6 1 7 1",
    stroke: "#B1A38A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H1L3 4h1.5",
    stroke: "#B1A38A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16h7L11 4H9.5M5 4h4",
    stroke: "#B1A38A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgShoppingBagIcon;